import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const hashtagImporterSelectors = importerSelectors(
  'hashtag.importer',
)

export default hashtagImporterSelectors
